module.exports = __webpack_public_path__ + "/images/ico-cart.1fd1b6b.svg";